import React from "react";
import { MessageSquare as MessageSquareText, Check, X } from "lucide-react";
import { cn } from "@/lib/utils";

export const DogItemContent = ({
  dog,
  isCompleted,
  handleItemClick,
  hasNote = false,
  // Props de confirmación opcional
  isPending = false,
  pendingIsCurrentlyCompleted = false,
  pendingType,              // 'marking' | 'urgent' | undefined
  pendingIsCurrentlyUrgent = false,
  onConfirmAction,
  onCancelAction,
}) => {
  const hasInformativeNote =
    dog.informativeNote && dog.informativeNote.trim() !== "";

  // Modo confirmación: mostrar prompt con botones ✓ y ✗
  if (isPending) {
    // Texto según tipo de confirmación pendiente
    let actionText;
    if (pendingType === 'urgent') {
      actionText = pendingIsCurrentlyUrgent ? '¿Quitar anulación?' : '¿Anular cliente?';
    } else {
      // type === 'marking' o sin tipo (retrocompatibilidad)
      actionText = pendingIsCurrentlyCompleted
        ? `¿Desmarcar ${dog.name}?`
        : `¿Marcar ${dog.name}?`;
    }

    return (
      <div className={cn(
        "flex items-center flex-grow min-w-0 gap-2",
        pendingType === 'marking' && 'flex-row-reverse'
      )}>
        {/* Texto de la acción pendiente */}
        <span className="text-sm font-semibold text-amber-800 dark:text-amber-200 flex-grow min-w-0 truncate select-none">
          {actionText}
        </span>

        {/* Grupo de botones: mantiene siempre el orden ✓ → X */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Botón confirmar (tick verde) */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onConfirmAction?.();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onConfirmAction?.();
              }
            }}
            className="flex-shrink-0 h-8 w-8 rounded-full bg-green-500 hover:bg-green-600 active:bg-green-700 text-white flex items-center justify-center transition-colors"
            aria-label="Confirmar"
          >
            <Check className="h-4 w-4" />
          </button>

          {/* Botón cancelar (aspa roja) */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onCancelAction?.();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onCancelAction?.();
              }
              if (e.key === "Escape") {
                e.preventDefault();
                onCancelAction?.();
              }
            }}
            className="flex-shrink-0 h-8 w-8 rounded-full bg-red-500 hover:bg-red-600 active:bg-red-700 text-white flex items-center justify-center transition-colors"
            aria-label="Cancelar"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }


  // Modo normal: comportamiento actual
  return (
    <div className="flex items-start flex-grow min-w-0">
      <div
        className={cn(
          "flex items-center gap-2 pr-3 pl-1 py-1 rounded-xl flex-grow min-w-0",
          hasNote && "bg-note-yellow"
        )}
      >
      <div
        className="flex flex-col flex-grow min-w-0"
        onClick={(e) => {
          console.error('[TAP_CONTENT]', JSON.stringify({ n: dog.name, type: e.nativeEvent?.type ?? e.type, t: Date.now() }));
          handleItemClick();
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleItemClick();
          }
        }}
      >
          <div className="flex items-center">
            <span
              className={cn(
                "text-sm font-semibold select-none",
                hasNote
                  ? "text-foreground dark:text-white"
                  : "text-foreground"
              )}
            >
              {dog.name}
            </span>
          </div>

          {hasInformativeNote && (
            <div className="flex items-start mt-1">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 border border-amber-300 dark:border-amber-700">
                <MessageSquareText className="h-3 w-3 flex-shrink-0" />
                <span className="break-words whitespace-pre-wrap">{dog.informativeNote}</span>
              </span>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};
